import { render, staticRenderFns } from "./FacebookButton.vue?vue&type=template&id=a42f3a40&scoped=true"
import script from "./FacebookButton.vue?vue&type=script&lang=js"
export * from "./FacebookButton.vue?vue&type=script&lang=js"
import style0 from "./FacebookButton.vue?vue&type=style&index=0&id=a42f3a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42f3a40",
  null
  
)

export default component.exports